import {useTranslation} from 'react-i18next';
import {Button, Grid, TextField} from '@material-ui/core';
import MultiSelect from "shared/FormComponents/MultiSelect";
import {DateInput} from 'shared/FormComponents';
import {Authorize} from '@postinumero/authorization';
import {CONSOLIDATED} from "../../../../shared/Types";

export default function Filters({activeFilters, setFilters, statuses, types, reset}) {
  const [t] = useTranslation();
  const handleValueChange = (value, key) => {
    setFilters({...activeFilters, [key]: value});
  }

  const handleSearchTextBlur = e => {
    const value = e.target.value ?? "";
    if (activeFilters.search !== value) {
      handleValueChange(value, 'search');
    }
  };

  const handleTypesChange = (types) => {
    if (types.includes(CONSOLIDATED)) {
      if (activeFilters.types.includes(CONSOLIDATED)) {
        // other type was added, we must remove consolidated
        types = types.filter(type => type !== CONSOLIDATED);
      } else {
        // consolidate type was added, we must reset all other types
        types = [CONSOLIDATED];
      }
    }
    handleValueChange(types, 'types');
  };

  return (
    <Grid container spacing={3} alignItems="flex-end">
      <Grid item xs={12} sm={6} md={3} lg={2}>
        <MultiSelect
          valueContainer={activeFilters.statuses}
          name={"statuses"}
          setValue={handleValueChange}
          options={statuses}
          label={t("filter.status")}
        />
      </Grid>
      <Authorize allow={['Issuer agent', 'Inspector']}>
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <MultiSelect
            valueContainer={activeFilters.types}
            name={"types"}
            setValue={handleTypesChange}
            options={types}
            label={t("filter.type")}
          />
        </Grid>
      </Authorize>
      <Grid item xs={12} sm={6} md={3} lg={2}>
        <TextField
          key={activeFilters.search}
          defaultValue={activeFilters.search}
          variant="outlined"
          fullWidth
          onBlur={handleSearchTextBlur}
          label={t("filter.search")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3} lg={2}>
        <DateInput
          value={activeFilters.startDate}
          maxDate={activeFilters.endDate ?? new Date('2100-01-01')}
          onChange={(event) => handleValueChange(event, 'startDate')}
          label={t("filter.startDate")}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3} lg={2}>
        <DateInput
          value={activeFilters.endDate}
          minDate={activeFilters.startDate ?? new Date('1900-01-01')}
          onChange={(event) => handleValueChange(event, 'endDate')}
          label={t("filter.endDate")}
        />
      </Grid>
      <Grid item>
        <Button
          size="large"
          variant="outlined"
          color="primary"
          onClick={reset}>
          {t("filter.reset")}
        </Button>
      </Grid>
    </Grid>
  );
}
